export default __webpack_public_path__ + "static/media/bitski.a30bbad8.svg";